import services from '../services'

export default {
  getOnDutyDrivers (VueApp, callback) {
    let self = this
    let token = VueApp.$store.state.session.sessionToken
    let request = {
      token: token,
      duty: 1,
      pageNum: VueApp.$store.state.laxit.onDuty.pageNum,
      pageSize: VueApp.$store.state.laxit.onDuty.pageSize,
      order: VueApp.$store.state.laxit.onDuty.order,
      orderAsc: VueApp.$store.state.laxit.onDuty.asc ? 1 : 0
    }
    VueApp.$sdk.get('/provider', request, r => {
      console.log(5, r)
      if (r.error) {
        console.log('ON DUTY ERROR:', r)
        callback(r)
        return
      }

      let result = []
      for (let i = 0; i < r.list.length; i++) {
        result.push(self.formatData(r.list[i], false, VueApp))
      }

      // VueApp.$store.commit('dispatch/setServiceCount', r.services)
      VueApp.$store.commit('laxit/setOnDutyDrivers', result)
      if (r.paging) {
        VueApp.$store.commit('laxit/setOnDutyTotalPages', r.paging.totalItems)
      }
      callback(r)
    })
  },
  formatData (item, isNew, VueApp) {
    let serviceTypes = []

    if (Array.isArray(item.services)) {
      for (let i = 0; i < item.services.length; i++) {
        serviceTypes.push({
          label: services.getServiceName(item.services[i]),
          class: item.services[i].toLowerCase()
        })
      }
    } else {
      for (let property in item.services) {
        if (!item.services.hasOwnProperty(property) || property === 'undefined') {
          continue
        }
        serviceTypes.push({
          label: services.getServiceName(property),
          class: property.toLowerCase()
        })
      }
    }

    let onBoard = 0
    let status = 'Available'
    if (item.rsvp !== null) {
      onBoard = item.rsvp.passengers
      status = 'Ongoing'
    }

    if (item.stagingLot !== null && item.rsvp === null) {
      status = 'On Staging'
    }

    let stagingLot = null

    if (item.stagingLot) {
      stagingLot = {}
      stagingLot.id = item.stagingLot.geofenceId
      stagingLot.name = item.stagingLot.geofenceName
      stagingLot.services = []

      let stagingServices = item.stagingLot.services
      for (let i = 0; i < stagingServices.length; i++) {
        let stagingService = stagingServices[i]
        let serviceName = ''
        if (!stagingService.serviceType) {
          let serviceList = VueApp.$store.state.services.list
          let index = serviceList.findIndex(x => x.id === stagingService.serviceTypeId)
          if (index > -1) {
            serviceName = serviceList[index].label
          }
        } else {
          serviceName = stagingService.serviceType === 'suv' ? 'SUV' :
          stagingService.serviceType.toLowerCase().replace(/(^| )(\w)/g, s => s.toUpperCase())
        }
        // let serviceName = stagingService.serviceType === 'suv' ? 'SUV' :
        // stagingService.serviceType.toLowerCase().replace(/(^| )(\w)/g, s => s.toUpperCase())
        let serviceStatus = stagingService.status === 'ondeck' ? 'OnDeck' :
                            stagingService.status.toLowerCase().replace(/(^| )(\w)/g, s => s.toUpperCase())

        stagingLot.services.push({
          serviceTypeId: stagingService.serviceTypeId,
          serviceName: serviceName,
          serviceClass: stagingService.serviceType,
          status: serviceStatus,
          priority: stagingService.priority
        })
      }
    }

    let driverData = {
      id: item.ID,
      firstName: item.firstName,
      lastName: item.lastName,
      phone: item.phone,
      email: item.email,
      photoUrl: item.avatarUrl,
      licenseType: item.providerAccountType,
      serviceTypes: serviceTypes,
      businessName: item.businessName,
      capacity: item.vehicle.seatCapacity,
      onBoard: onBoard,
      status: status,
      isNew: isNew,
      coords: {
        lat: null,
        lng: null
      },
      vehicle: {
        name: item.vehicle.manufacturer + ' ' + item.vehicle.model,
        licensePlate: item.vehicle.licensePlate,
        photoUrl: item.vehicle.photoUrl ? item.vehicle.photoUrl : item.vehicle.photo
      },
      rsvp: item.rsvp,
      stagingLot: stagingLot
    }
    // if (!CONFIG.useOldQuatation) {
    //   driverData.serviceTypes
    // }

    return driverData
  }
}


// WEBPACK FOOTER //
// ./src/modules/api/laxit/drivers.js